import { VFC } from "react";

import useLDFlag from "hooks/useLDFlag";

import { Mode, PublicQuoteRequest } from "../../api/types/generated-types";
import BenchmarkRateEstimatesContainer from "./containers/BenchmarkRateEstimatesContainer";

type BenchmarkRateEstimatesDashboardProps = {
  publicQuoteRequest: PublicQuoteRequest;
};

const BenchmarkRateEstimatesDashboard: VFC<BenchmarkRateEstimatesDashboardProps> = ({ publicQuoteRequest }) => {
  const enableBenchmarkRateEstimates = useLDFlag("enableBenchmarkRateEstimates");
  // If feature is off, return null
  if (!enableBenchmarkRateEstimates) {
    return null;
  }

  // Only allow FTL or LTL
  if (publicQuoteRequest.mode != Mode.Ftl && publicQuoteRequest.mode != Mode.Ltl) {
    return null;
  }

  // Render container, passing the data along
  return <BenchmarkRateEstimatesContainer publicQuoteRequest={publicQuoteRequest} />;
};

export default BenchmarkRateEstimatesDashboard;
